import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon, USER_INTERFACE_ARROW_04_DOWN } from '@bwoty-web/styleguide';

import styles from './SearchOptionButton.scss';

const SearchOptionButton = (props) => {
  const { header, children, className, isOpen, onClick, isOtherActive, testSelector } = props;

  const c = classNames(className, styles.root, {
    [styles.isOpen]: isOpen,
    [styles.inActive]: isOtherActive,
  });

  return (
    <button type="button" className={c} onClick={onClick} data-test={testSelector}>
      <span className={styles.header}>{header}</span>
      <div className={styles.label} data-test={testSelector ? `${testSelector}-value` : undefined}>
        {children}
      </div>
      <Icon path={USER_INTERFACE_ARROW_04_DOWN} size="xxs" className={styles.arrow} />
    </button>
  );
};

SearchOptionButton.propTypes = {
  isOpen: PropTypes.bool,
  isOtherActive: PropTypes.bool,
  className: PropTypes.string,
  testSelector: PropTypes.string,
  header: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default SearchOptionButton;
